module.exports = __webpack_public_path__ + "static/img/lizhi.1bc2078d.png";